// extracted by mini-css-extract-plugin
export default {"mainContainer":"bpmSlider_mainContainer__6ieUs","sliderBox":"bpmSlider_sliderBox__LSQrQ"};